export default __webpack_public_path__ + "static/media/confirmation_complete.a49048b1.png";